import React from "react";
import PropTypes from "prop-types";

const ItemStatus = ({status}) => {
    switch (status) {
        case 'ALARM':
            return (<i className="fa fa-exclamation-triangle red-icon" title={status}/>);
        case 'WARNING':
            return (<i className="fa fa-exclamation-triangle yellow-icon" title={status}/>);
        case 'NORMAL':
            return (<img className="event-icon" src="../../../images/event.svg" alt={status} title={status}/>);
        case 'OK':
            return (<i className="fa fa-check-circle status-icon-ok" title={status}/>);
        default:
            return (<i className="fa fa-exclamation-triangle" title={status}/>);
    }
};
ItemStatus.propTypes = {
    status: PropTypes.string
};

export default ItemStatus;